import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toggleLabel: {
		id: 'personal-settings-preference-fields.common.notify-own-changes.toggle-label',
		defaultMessage: 'Receive emails when you make changes to issues',
		description: 'Label for toggling notify own changes on/off',
	},
	checkboxLabel: {
		id: 'personal-settings-preference-fields.common.notify-own-changes.checkbox-label',
		defaultMessage: 'You make changes to issues',
		description: 'Label for toggling notify own changes on/off',
	},
	toggleLabelIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.notify-own-changes.toggle-label-issue-term-refresh',
		defaultMessage: 'Receive emails when you make changes to work items',
		description: 'Label for toggling notify own changes on/off',
	},
	checkboxLabelIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.notify-own-changes.checkbox-label-issue-term-refresh',
		defaultMessage: 'You make changes to work items',
		description: 'Label for toggling notify own changes on/off',
	},
});
